import React from 'react';
import Select from 'react-select';
import StatsTable from '@/AdminComponent/Reactions/components/Stats/StatsTable';
import { useCompare } from '@/AdminComponent/Reactions/hooks/useCompare';
import '@/AdminComponent/Reactions/components/Compare/ComparisonModal.css';

const ComparisonModal = ({ isOpen, onClose, groupBy }) => {
	const {
		selectionOptions,
		isOptionsLoading,
		primarySelection,
		secondarySelection,
		primaryStats,
		secondaryStats,
		isPrimaryStatsLoading,
		isSecondaryStatsLoading,
		isCategoryGrouping,
		handlePrimarySelect,
		handleSecondarySelect
	} = useCompare(isOpen, groupBy);

	if (!isOpen) return null;

	const placeholderText = `Search by ${isCategoryGrouping ? 'Category' : 'Instructor'} Name...`;

	return (
		<div className="compare-modal-overlay">
			<div className="compare-modal-content">
				<div className="compare-modal-header">
					<h2>Compare {isCategoryGrouping ? 'Categories' : 'Instructors'}</h2>
					<button onClick={onClose} className="compare-close-button">
						&times;
					</button>
				</div>

				<div className="compare-selection-container">
					<div className="compare-selector-col">
						<label>Select Item 1:</label>
						<Select
							options={selectionOptions}
							onChange={handlePrimarySelect}
							value={primarySelection}
							isLoading={isOptionsLoading || isPrimaryStatsLoading}
							isDisabled={isPrimaryStatsLoading || isOptionsLoading}
							placeholder={placeholderText}
						/>
					</div>

					<div className="compare-selector-col">
						<label>Select Item 2:</label>
						<Select
							options={selectionOptions}
							onChange={handleSecondarySelect}
							value={secondarySelection}
							isLoading={isOptionsLoading || isSecondaryStatsLoading}
							isDisabled={isSecondaryStatsLoading || isOptionsLoading}
							placeholder={placeholderText}
						/>
					</div>
				</div>

				<div className="comparison-grid">
					<div className="comparison-col">
						<StatsTable stats={primaryStats} groupBy={groupBy} isLoading={isPrimaryStatsLoading} />
					</div>
					<div className="comparison-col">
						<StatsTable stats={secondaryStats} groupBy={groupBy} isLoading={isSecondaryStatsLoading} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ComparisonModal;
